// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".em-file-input__file-container{display:flex;border:1px solid #ccc;border-radius:2px;padding:7px;align-items:center}.em-file-input__file-container .em-file-input__file-name{flex-grow:1}.em-file-input__file-container .em-file-input__file-name--placeholder{opacity:.6}.em-file-input__file-container>.btn{margin-left:15px}.em-file-input__file-container>input[type=file]{display:none}", ""]);
// Exports
module.exports = exports;
